import { render, staticRenderFns } from "./Transport.vue?vue&type=template&id=35a83dae&scoped=true&"
import script from "./Transport.vue?vue&type=script&lang=js&"
export * from "./Transport.vue?vue&type=script&lang=js&"
import style0 from "./Transport.vue?vue&type=style&index=0&id=35a83dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a83dae",
  null
  
)

export default component.exports